import { Form, Modal } from "antd";
import React from "react";
import { CreateWaterConsumptionIntakeDto } from "../../../../api";
import { WaterConsumptionIntakeColumns } from "../form/columns";

interface WaterConsumptionIntakeFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWaterConsumptionIntake: (values: CreateWaterConsumptionIntakeDto) => void;
}

export const WaterConsumptionIntakeForm: React.FC<WaterConsumptionIntakeFormProps> = ({ visible, setVisible, onCreateWaterConsumptionIntake }) => {
  const [form] = Form.useForm<CreateWaterConsumptionIntakeDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWaterConsumptionIntake}>
        {WaterConsumptionIntakeColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
